var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"d-flex align-center mb-2",class:_vm.outlined ? 'mt-n6' : 'mt-n2',staticStyle:{"color":"#1976d2","font-size":"12px"}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":"#1976d2"}},[_vm._v("mdi-information")]),_c('span',[_vm._v(_vm._s(_vm.computedMessage))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }